import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { MapSettingsColorBlock } from "./MapSettingsColorBlock";
import { MapSettings, MapSettingsColor, MapSettingsCreate } from "../../../services/models/map_settings";
import styles from "./MapSettingsColorModal.module.css";
import { useUpdateMapSettings } from "../../../hooks/useQuery";
import classNames from "classnames";

interface MapSettingsColorModalProps {
    show?: boolean;
    onHide?: () => void;
    mapSettingsData: MapSettings;
}

export const MapSettingsColorModal: React.FC<MapSettingsColorModalProps> = ({
    show = false,
    onHide = () => {},
    mapSettingsData,
}) => {
    const [colors, setColors] = useState<MapSettingsColor[]>([]);
    const [isColorPickerVisible, setIsColorPickerVisible] = useState(false);
    const { updateMapSettings } = useUpdateMapSettings(false);

    useEffect(() => {
        if (mapSettingsData?.colors?.length) {
            setColors(mapSettingsData.colors);
        }
    }, [mapSettingsData]);

    const handleUpdateColors = (updatedColors: MapSettingsColor[]) => {
        const data: MapSettingsCreate = {
            tagId: "",
            moduleId: "",
            valueId: "",
            colors: updatedColors,
            indicatorType: mapSettingsData?.indicatorType || "data_user", // TODO: data_rf
            indicatorDataRF: mapSettingsData?.indicatorDataRF || "surgicalBedsForChildren",
        };

        if (mapSettingsData) {
            data.tagId = mapSettingsData.tag?.id || "";
            data.moduleId = mapSettingsData.module?.id || "";
            data.valueId = mapSettingsData.value?.id || "";
        }

        updateMapSettings(data);
        onHide();
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            contentClassName={classNames(styles.modalContent, {
                [styles.hidden]: isColorPickerVisible,
            })}
        >
            <Modal.Header closeButton className={styles.modalHeader}>
                <Modal.Title id="contained-modal-title-vcenter">Настройка цветов показателей</Modal.Title>
            </Modal.Header>
            <Modal.Body className={styles.modalBody}>
                <MapSettingsColorBlock
                    colors={colors}
                    onSave={handleUpdateColors}
                    onColorPickerVisibilityChange={setIsColorPickerVisible}
                />
            </Modal.Body>
        </Modal>
    );
};
